import React from "react";
import { URL_DELIVERY } from "../../constants/urls";
import TSTable from "./TSTable";
import { Modal } from "antd";
import { useTranslation } from "react-i18next"; 

export default function EudrPlantationListModal(props) {
  const { t } = useTranslation();
  const tableRef = React.useRef();
  const [url, setUrl] = React.useState(null)
  const columns = [
    {
      title: t("plot_code"),
      dataIndex: 'code',
    },
    {
      title: t("factory_del.is_eudr_comply"),
      dataIndex: 'eudr_status',
      searcher: true,
      searcherOptions: [
        {value: 'a. Compliant', label: 'a. Compliant'},
        {value: 'b. Await for mitigation report', label: 'b. Await for mitigation report'},
        {value: 'b. Non-compliant', label: 'b. Non-compliant'},
        {value: 'c. Compliant - With mitigation', label: 'c. Compliant - With mitigation'},
      ]
    },
    {
      title: t("plantations.detail"),
      dataIndex: 'eudr_issues',
    }
  ]

  React.useEffect(() => {
    if (props.target) {
      setUrl(`${URL_DELIVERY.PLANTATION_EUDR_DETAILS}${props.target}`)
    }
  }, [props.target])

  React.useEffect(() => {
    if (url && tableRef.current) {
      tableRef.current.fetch()
    }
  }, [url])

  return (
    <Modal
      open={props.open}
      onCancel={props.onClose}
      title={<>{t('plantations.detail') }</>}
      width={1000}
      closeIcon
      footer={[]}
    >
      <TSTable
        ref={tableRef}
        columns={columns}
        url={url}
        additional_params={{'non-eudr-only': true}}
        rowKey={'id'}
        size={'small'}
        pageSize={10}
        autoFetch={false}
      />
    </Modal>
  )
}